import React from "react";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useState } from "react";
import { getByName, getActivities, getCountries } from "../../redux/actions";
import style from "./searchBar.module.css";

export default function SearchBar({setCurrentPage}) {
  const dispatch = useDispatch();
  const [name, setName] = useState("");
  const [search, setSearch] = useState(false);

  function handleInputChange(e) {
    e.preventDefault();
    setName(e.target.value);
  }

  function handleSubmit(e) {
   /*  e.preventDefault();
    dispatch(getByName(name));
    if(name) { */
    e.preventDefault();
    setCurrentPage(1);
    dispatch(getByName(name));
    setSearch(true);
    setName("")
   /*  } else {
    e.preventDefault();
     setSearch(false)
     setName("")
    } */
  }
  
  useEffect(() => {
    dispatch(getCountries());
    dispatch(getActivities());
  }, [dispatch]); 

  return (
    <div className={style.in}>
      <input
        type="text"
        placeholder="Search..."
        onChange={(e) => handleInputChange(e)}
      />

      <button type="submit" onClick={(e) => handleSubmit(e)}>
        Search
      </button>
    </div>
  );
}


//const [name, setName] = useState("");
  //const [search, setSearch] = useState(false);

 // function handleName(e) {
   // e.preventDefault();
    //setName(e.target.value); 
 // }

  //function handleSubmit(e) {
    // e.preventDefault();
    // dispatch(getDogsByName(name));
    //if(name) {
     // e.preventDefault();
      //dispatch(getDogsByName(name));
      //setSearch(true);
      //setName("")
    //} else {
      // e.preventDefault();
      // setSearch(false)
      // setName("")
    //}